import { useState } from "react";
import {
  Button,
  Flex,
  FormLabel,
  Image,
  Input,
  Text,
  FormControl,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Form, Formik } from "formik";
import { ForgotPasswordSchema } from "../utils/formValidationSchema";
import { forgotPassword } from "../services/authService";
import LoginImage from "../components/LoginImage";
import { BiArrowBack } from "react-icons/bi";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  

  const emailFromState = location.state?.email || "";

  const initialValues = {
    otp: "",
    email: emailFromState,
    newPassword: "",
    confirmPassword: "",
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const resetData = {
        otp: values.otp,
        email: values.email,
        otpType: "ResetPassword",
        newPassword: values.newPassword
      };

      const response = await forgotPassword(resetData);
      if (response?.isSuccessful) {
        

        navigate("/");
      } else {
        throw new Error(
          response?.data?.responseDescription || "Something went wrong"
        );
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex w="full" h="100vh" overflow="hidden">
      <Flex h="100vh" w="full" justify="center" position="relative" overflow="hidden">
        <Flex w={["90%", "80%", "90%", "55%"]} h="full" overflow="hidden">
          <Flex
            direction="column"
            bg="white"
            width="full"
            px="1.5rem"
            py="2rem"
            
          >
            <Box h="5rem" mb={6}>
              <Image src="/Vatebra-Logo.png" />
            </Box>

            <BiArrowBack
              size="1.5rem"
              style={{ marginBottom: "1.5rem", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />

            <Flex justify="space-between" direction="column" mb="1.5rem">
              <Text fontWeight="700" fontSize="1.8rem">
                Reset Your Password
              </Text>
              <Text fontSize="1.25rem">
                Enter the OTP sent to your email and your new password to reset your account.
              </Text>
            </Flex>

            {error && (
              <Alert status="error" mb="1rem">
                <AlertIcon />
                <AlertTitle>{error}</AlertTitle>
              </Alert>
            )}

            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={ForgotPasswordSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form>
                  

                  <FormControl
                    isInvalid={formik.errors.otp && formik.touched.otp}
                    mb={4}
                    color="black"
                  >
                    <FormLabel>OTP</FormLabel>
                    <Input
                      placeholder="Enter OTP"
                      bgColor="#F3F3F3"
                      borderRadius={0}
                      borderColor="transparent"
                      name="otp"
                      value={formik.values.otp}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.otp && formik.errors.otp && (
                      <FormErrorMessage>{formik.errors.otp}</FormErrorMessage>
                    )}
                  </FormControl>

                  <FormControl
                    isInvalid={formik.errors.newPassword && formik.touched.newPassword}
                    mb={4}
                    color="black"
                  >
                    <FormLabel>New Password</FormLabel>
                    <Input
                      type="password"
                      placeholder="Enter new password"
                      bgColor="#F3F3F3"
                      borderRadius={0}
                      borderColor="transparent"
                      name="newPassword"
                      value={formik.values.newPassword}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.newPassword && formik.errors.newPassword && (
                      <FormErrorMessage>{formik.errors.newPassword}</FormErrorMessage>
                    )}
                  </FormControl>

                  <FormControl
                    isInvalid={formik.errors.confirmPassword && formik.touched.confirmPassword}
                    mb={6}
                    color="black"
                  >
                    <FormLabel>Confirm Password</FormLabel>
                    <Input
                      type="password"
                      placeholder="Confirm new password"
                      bgColor="#F3F3F3"
                      borderRadius={0}
                      borderColor="transparent"
                      name="confirmPassword"
                      value={formik.values.confirmPassword}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                      <FormErrorMessage>{formik.errors.confirmPassword}</FormErrorMessage>
                    )}
                  </FormControl>

                  <Button
                    isLoading={isLoading}
                    color="white"
                    bgColor="#005E39"
                    borderRadius="8px"
                    mt="1rem"
                    mb="2rem"
                    w="full"
                    type="submit"
                    _hover={{ bgColor: "#00452b" }}
                  >
                    Reset Password
                  </Button>
                </Form>
              )}
            </Formik>
          </Flex>
        </Flex>
      </Flex>

      <LoginImage />
    </Flex>
  );
};

export default ForgotPassword;